import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HomeComponent } from "./components/new-product/home/home.component";
import { IbgSgUploadComponent } from "./components/product/ibg-sg-upload/ibg-sg-upload.component";
import { RmScreenComponent } from "./components/product/rm-screen/rm-screen.component";
import { AutoLoanRedemptionComponent } from "./components/product/auto-loan-redemption/auto-loan-redemption.component";
import { BouncedMailPolicyComponent } from "./components/product/bounced-mail-policy/bounced-mail-policy.component";
import { ReviewRefundUploadComponent } from "./components/accounting/review-refund-upload/review-refund-upload.component";
import { RefundUploadComponent } from "./components/accounting/refund-upload/refund-upload.component";
import { Adb2cLoginRedirectComponent } from "./components/login/adb2c-login-redirect/adb2c-login-redirect.component";
import { Adb2cLoginComponent } from "./components/login/adb2c-login/adb2c-login.component";
import { AuthGuard } from "./components/security/auth.guard";
import { MultiYearAutoDebitUploadComponent } from "./components/product/multi-year-auto-debit-upload/multi-year-auto-debit-upload.component";
import { PolicyWordigSetupComponent } from "./components/product/policyWordingSetUp/policy-wording-setup.component";
import { LstRateComponent } from "./components/product/lst-rate/lst-rate.component";
import { BatchInvoiceListComponent } from "./components/accounting/batch-invoice/batch-invoice-list.component";
import { UserProfileComponent } from "./components/admin/user-profile/user-profile.component";
import { CustomerLoginComponent } from "./components/login/customer-login/customer-login.component";
import { CustomerEnterOtpComponent } from "./components/login/customer-login/customer-enter-otp.component";
import { CustomerAcceptOfferComponent } from "./components/login/customer-login/customer-accept-offer.component";
import { Adb2cUserTypeListingComponent } from "./components/login/adb2c-user-type-listing/adb2c-user-type-listing.component";
import { GstAdjustmentComponent } from "./components/accounting/gst-adjustment/gst-adjustment.component";
import { UserRoleSelectionComponent } from "./components/login/user-role-selection/user-role-selection.component";
import { BaseProposalComponent } from "./components/new-product/base/base-proposal/base-proposal.component";
import { BaseOpenItemListComponent } from "./components/new-product/base/base-open-item-list/base-open-item-list.component";
import { BaseReconcileListComponent } from "./components/new-product/base/base-reconcile-list/base-reconcile-list.component";
import { EndorsementListComponent } from "./components/new-product/sme/mortgage-fire/hong-kong/components/endorsement/endorsement-list/endorsement-list.component";
import { ConfigurablesComponent } from "./components/new-product/sme/mortgage-fire/hong-kong/components/configurables/configurables.component";
export const ROUTE_LOGIN = ""; //todo, unify with "src/app/app.module"
export const ROUTE_HOME = "product/home"; //todo, unify with "src/app/app.module"
export const ROUTE_PROPOSAL = "proposal"; //todo, unify with "src/app/app.module"
export const ROUTE_CUSTOMER_LOGIN = "customerLogin";
export const ROUTE_USER_TYPE_LISTING = "adb2cUserTypeListing";
export const ROUTE_USER_ROLE_SELECTION = "userroleselection";

const routes = [
  {
    path: ROUTE_LOGIN,
    component: Adb2cLoginComponent, //HomeComponent,
    text: "",
  },
  {
    path: ROUTE_USER_ROLE_SELECTION,
    component: UserRoleSelectionComponent,
    text: "user role selection",
    canActivate: [AuthGuard],
    // data: {
    //   role: "hasProductReadWriteRoles",
    // },
  },
  {
    path: ROUTE_HOME, //follow old angular
    component: HomeComponent,
    text: "Home",
    canActivate: [AuthGuard],
    data: {
      role: "hasProductReadWriteRoles",
    },
  },
  {
    path: ROUTE_PROPOSAL,
    component: BaseProposalComponent,
    text: "Proposal",
    canActivate: [AuthGuard],
    data: {
      role: "hasProductTransactRoles",
    },
  },
  //{ path: 'proposal/:id/:guid', component: HomeComponent },
  {
    path: ROUTE_CUSTOMER_LOGIN,
    component: CustomerLoginComponent,
    text: "Customer Login",
  },
  {
    path: "customerEnterOtp/:enc/:email/:mobile/:dob/:last4UniqueId",
    component: CustomerEnterOtpComponent,
    text: "",
  },
  {
    path: "customerAcceptOffer/:enc/:proposalIdList/:productList/:policyList/:expiryDateList",
    component: CustomerAcceptOfferComponent,
    text: "",
  },
  {
    path: "", //follow old angular
    text: "Accounting",
    children: [
      {
        path: "openItem",
        component: BaseOpenItemListComponent,
        text: "Open Item",
        canActivate: [AuthGuard],
        data: {
          role: "isFinanceAccounting",
        },
      },
      {
        path: "batchInvoice",
        component: BatchInvoiceListComponent,
        text: "Batch Invoice",
        canActivate: [AuthGuard],
        data: {
          role: "isFinanceAccounting",
        },
      },
      {
        path: "reconcile",
        component: BaseReconcileListComponent,
        text: "Reconcile",
        canActivate: [AuthGuard],
        data: {
          role: "isFinanceAccounting",
        },
      },
      {
        path: "reviewRefundUpload",
        component: ReviewRefundUploadComponent,
        text: "Bulk Refund in Review Upload",
        canActivate: [AuthGuard],
        data: {
          role: "isFinanceAccounting",
        },
      },
      {
        path: "refundUpload",
        component: RefundUploadComponent,
        text: "Bulk Refund Upload",
        canActivate: [AuthGuard],
        data: {
          role: "isFinanceAccounting",
        },
      },
      {
        path: "dbsAccountingGSTAdjustmentUpload",
        component: GstAdjustmentComponent,
        text: "GST Adjustment Upload",
        canActivate: [AuthGuard],
        data: {
          role: "isFinanceAccounting",
        },
      },
    ],
  },
  //todo: new angular has to use extra queryParams to differentiate?
  {
    path: "", //follow old angular
    text: "Product",
    children: [
      {
        path: "customerLogin",
        component: CustomerLoginComponent,
        text: "CustomerLogin",
        canActivate: [AuthGuard],
        data: {
          role: "isUnderwriter|isIBGProductTab",
        },
      },
      {
        path: "uploadExcelCreate",
        component: IbgSgUploadComponent,
        text: "IBG (SG) - Upload",
        canActivate: [AuthGuard],
        data: {
          role: "isUnderwriter|isIBGProductTab",
        },
      },
      {
        path: "rmscreen",
        component: RmScreenComponent,
        text: "RM Screen",
        canActivate: [AuthGuard],
        data: {
          role: "isUnderwriter|isIBGProductTab",
        },
      },
      {
        path: "lstRate",
        component: LstRateComponent,
        text: "LSTRates",
        canActivate: [AuthGuard],
        data: {
          role: "isUnderwriter|isIBGProductTab",
        },
      },
      {
        path: "autoLoanRedemption?type=CBG",
        component: AutoLoanRedemptionComponent,
        text: "CBG Loan Redemption - Upload",
        data: {
          type: "CBG",
          role: "isUnderwriter|isIBGProductTab",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "autoLoanRedemption?type=IBG",
        component: AutoLoanRedemptionComponent,
        text: "IBG Loan Redemption - Upload",
        data: {
          type: "IBG",
          role: "isUnderwriter|isIBGProductTab",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "autoLoanRedemption?type=Citi",
        component: AutoLoanRedemptionComponent,
        text: "Citi Loan Redemption - Upload",
        data: {
          type: "Citi",
          role: "isUnderwriter|isIBGProductTab",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "bouncedMailPolicy",
        component: BouncedMailPolicyComponent,
        text: "Bounced Mail Policy",
        data: {
          role: "isUnderwriter|isIBGProductTab|isOperationUnderwriter",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "policyWordingSetUp",
        component: PolicyWordigSetupComponent,
        text: "Policy Wording SetUp",
        data: {
          role: "isUnderwriter|isIBGProductTab|isOperationUnderwriter",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "multiYearAutoDebit",
        component: MultiYearAutoDebitUploadComponent,
        text: "Multiyear AutoDebit - Upload",
        data: {
          role: "isUnderwriter|isIBGProductTab",
          type: "CBG",
        },
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "", //follow old angular
    text: "Configurables",
    children: [
      {
        path: "configurables",
        component: ConfigurablesComponent,
        text: "Endorsement Clause",
        canActivate: [AuthGuard],
        data: {
          role: "isUnderwriter",
        },
      },
    ],
  },
  //admin
  {
    path: "", //follow old angular
    text: "Admin",
    children: [
      {
        path: "userProfileList",
        component: UserProfileComponent,
        text: "User Profile",
        canActivate: [AuthGuard],
        data: {
          role: "showAdminTab",
        },
      },
    ],
  },
  { path: ROUTE_USER_TYPE_LISTING, component: Adb2cUserTypeListingComponent },
  {
    path: "adb2csso",
    component: Adb2cLoginRedirectComponent,
  },
  {
    path: "**",
    component: Adb2cLoginComponent,
  }, //todo: wildcard { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
